import Layout from "@/components/Layout";

const Terms = () => (
  <Layout>
    <div className="container mx-auto max-w-2xl px-4 py-10 space-y-6 text-slate-200">
      <h1 className="text-2xl font-bold text-white">Terms of Use</h1>
      <p className="text-sm text-slate-400">Last updated: March 2026</p>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Acceptable use</h2>
        <ul className="list-disc pl-5 space-y-1 text-sm text-slate-300">
          <li>Do not paste personal data (names, emails, addresses, phone numbers) into the tool.</li>
          <li>Do not use the service for illegal purposes or to process illegal content.</li>
          <li>Do not abuse the scraping functionality or attempt to overload the service.</li>
          <li>Do not bulk-copy copyrighted material beyond what constitutes fair use.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">No warranties</h2>
        <p className="text-sm text-slate-300">
          Reports are generated from publicly available sources and user-provided text. Outputs may be incomplete, inaccurate or out of date. You are responsible for verifying all claims, evidence and copy before publishing or using commercially.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Limitation of liability</h2>
        <p className="text-sm text-slate-300">
          ScopSift is provided "as is". We are not liable for any business outcomes, lost revenue, or damages arising from the use of generated reports or copy.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Account responsibility</h2>
        <p className="text-sm text-slate-300">
          You are responsible for keeping your account credentials secure. Any activity under your account is your responsibility.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Termination</h2>
        <p className="text-sm text-slate-300">
          We reserve the right to suspend or terminate accounts that violate these terms or abuse the service, without prior notice.
        </p>
      </section>
    </div>
  </Layout>
);

export default Terms;
